import { jsConfig } from '../config/jsConfig';
import { createConsoleMonitoring } from './console-monitoring';

/** Console backend for the browser — logs only in local/test so it never spams production users. */
export const clientConsoleMonitoring = createConsoleMonitoring(['local', 'test'].includes(jsConfig.sentryEnv));
